import { Link } from "react-router-dom";
import { ShieldCheck, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">

          {/* Colonne 1 : Marque */}
          <div className="lg:col-span-1">
            <div className="mb-3">
              <img
                src="/assets/blackoutgames.png"
                alt="Blackout Games"
                className="h-7 w-auto object-contain"
              />
            </div>
            <p className="text-[12px] text-slate-500 leading-relaxed max-w-xs">
              Escape games digitaux clé-en-main pour entreprises. 4 à 6 joueurs, navigateur uniquement, sans logistique.
            </p>
            <a
              href="mailto:contact@blackout-games.fr"
              className="mt-4 inline-flex items-center gap-2 text-[12px] text-slate-500 hover:text-indigo-600 transition"
            >
              <Mail className="h-3.5 w-3.5" />
              contact@blackout-games.fr
            </a>
          </div>

          {/* Colonne 2 : Produit */}
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">Produit</p>
            <ul className="space-y-2">
              {[
                { to: "/catalogue", label: "Catalogue des jeux" },
                { to: "/offres", label: "Tarifs & packs" },
                { to: "/guide", label: "Guide d'utilisation" },
                { to: "/roadmap", label: "Notre trajectoire" },
                { to: "/play", label: "Rejoindre une session" },
                { to: "/scoreboards", label: "Classements" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-[13px] text-slate-600 hover:text-indigo-600 transition">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 : Compte */}
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">Compte</p>
            <ul className="space-y-2">
              {[
                { to: "/signup", label: "Créer un compte" },
                { to: "/login", label: "Se connecter" },
                { to: "/profile", label: "Mon espace" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-[13px] text-slate-600 hover:text-indigo-600 transition">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 4 : Réassurance */}
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">Confiance</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-[12px] text-slate-500">
                <ShieldCheck className="h-4 w-4 text-indigo-500 shrink-0 mt-0.5" />
                <span>Paiement sécurisé via Stripe. Facture automatique après chaque achat.</span>
              </li>
              <li className="flex items-start gap-2 text-[12px] text-slate-500">
                <span className="mt-0.5 h-4 w-4 shrink-0 flex items-center justify-center text-orange-400 font-bold text-xs">✦</span>
                <span>Les visuels de nos jeux sont générés avec des outils d'IA, puis retravaillés par l'équipe Blackout Games.</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bandeau Partenaires */}
        <div className="mt-10 pt-6 border-t border-slate-100">
          <Link
            to="/devenir-partenaire"
            className="group flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 border border-orange-100 hover:border-orange-200 transition"
          >
            <div className="flex items-center gap-3">
              <span className="text-2xl">🤝</span>
              <div>
                <p className="text-[13px] font-semibold text-stone-800">
                  Vous êtes une escape room ou une boutique de jeux ?
                </p>
                <p className="text-[12px] text-stone-500">
                  Rejoignez notre programme partenaire et touchez 10% sur chaque première vente.
                </p>
              </div>
            </div>
            <span className="text-[12px] font-semibold text-orange-600 group-hover:text-orange-500 transition whitespace-nowrap">
              En savoir plus →
            </span>
          </Link>
        </div>

        {/* Bas de footer */}
        <div className="mt-10 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-slate-400">
          <p>© {new Date().getFullYear()} Blackout Games. Tous droits réservés.</p>
          <nav className="flex flex-wrap gap-4 sm:justify-end">
            <Link to="/mentions-legales" className="hover:text-slate-700 transition">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="hover:text-slate-700 transition">
              Politique de confidentialité
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}